export default "__VITE_ASSET__DXdlnXt2__"